var User = /** @class */ (function () {
    function User(obj, id) {
        if (id) {
            this.id = id;
        }
        this.email = obj.email;
        this.is_admin = obj.is_admin;
        this.is_confirmed = obj.is_confirmed;
    }
    Object.defineProperty(User.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "Email", {
        get: function () {
            return this.email;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "IsAdmin", {
        get: function () {
            return this.is_admin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "IsConfirmed", {
        get: function () {
            return this.is_confirmed;
        },
        enumerable: false,
        configurable: true
    });
    return User;
}());
export { User };
export function createUser(obj, id) {
    return new User(obj, id);
}
export function createUsers(rawUsers) {
    var users = [];
    var rawUsersData = rawUsers.data;
    for (var _i = 0, rawUsersData_1 = rawUsersData; _i < rawUsersData_1.length; _i++) {
        var rawUser = rawUsersData_1[_i];
        var user = createUser(rawUser.attributes, rawUser.id);
        users.push(user);
    }
    return users;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/user/user.ts
// module id = 494
// module chunks = 0